import enumBase from './EnumBase';

export default class EnvelopeTrigger extends enumBase {
  static SAVE_FILES_ON_DIRECTORY = 'SAVE_FILES_ON_DIRECTORY';
}
